<template>
    <span
        class="block rounded-full text-(--text-color) text-center bg-(--background-color) tracking-wide"
        :class="[props.variant === 'Gray' ? 'font-light' : 'font-medium']"
        :style="initialsColorStyle"
    >
        {{ initials }}
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getInitialsColor } from './getInitialsColor';

type InitialsWithBackgroundProps = {
    firstName: string;
    lastName: string;
    variant?: 'Default' | 'Gray';
};

const props = defineProps<InitialsWithBackgroundProps>();

const initials = computed(() => `${props.firstName.charAt(0)}${props.lastName.charAt(0).toUpperCase()}`);

const initialsColorStyle = computed(() => {
    return {
        '--background-color':
            props.variant === 'Gray' ? 'var(--color-gray-200)' : getInitialsColor(props.firstName, props.lastName),
        '--text-color': props.variant === 'Gray' ? 'var(--color-gray-500)' : 'var(--color-white)',
    };
});
</script>
